import { LucideIcon } from "lucide-react";

interface IconBoxProps {
  icon: LucideIcon;
  index: number;
  variant?: "subtle" | "badge";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const subtleSizeClasses = {
  sm: "w-5 h-5 p-3",
  md: "w-6 h-6 p-3.5",
  lg: "w-8 h-8 p-4",
  xl: "w-10 h-10 p-5",
};

const badgeSizeClasses = {
  sm: "w-10 h-10",
  md: "w-12 h-12",
  lg: "w-14 h-14",
  xl: "w-16 h-16",
};

const badgeIconSizes = {
  sm: "w-5 h-5",
  md: "w-6 h-6",
  lg: "w-7 h-7",
  xl: "w-8 h-8",
};

export default function IconBox({ 
  icon: Icon, 
  index, 
  variant = "subtle", 
  size = "lg", 
  className = "" 
}: IconBoxProps) {
  const isTeal = index % 2 === 0;

  // Badge style (older solid style with shadow)
  if (variant === "badge") {
    const badgeSize = badgeSizeClasses[size];
    const iconSize = badgeIconSizes[size];
    
    return (
      <div
        className={`${badgeSize} rounded-xl flex items-center justify-center shadow-lg ${
          isTeal ? "bg-accentcolourteal" : "bg-accentcolourorange"
        } flex-shrink-0 ${className}`}
      >
        <Icon className={`${iconSize} text-white`} />
      </div>
    );
  }

  // Subtle style (new transparent style)
  const iconSize = subtleSizeClasses[size].split(" ").slice(0, 2).join(" ");
  const padding = subtleSizeClasses[size].split(" ")[2];

  return (
    <div
      className={`${
        isTeal ? "bg-accentcolourteal/10" : "bg-accentcolourorange/10"
      } rounded-lg ${padding} flex-shrink-0 ${className}`}
    >
      <Icon
        className={`${iconSize} ${
          isTeal ? "text-accentcolourteal" : "text-accentcolourorange"
        }`}
      />
    </div>
  );
}